export default [
// { girl: '☺️', boy: '今天很開心喔😃' },
// { girl: '加囉~', boy: '哈囉 今天還蠻開心的 希望和你保持聯絡 願意的話加我臉書：*****' },
// { girl: '555555', boy: '安安' },
// { girl: '👍', boy: '有機會再約😉' },
// { girl: '哈哈哈不辛苦 謝謝你招待周全 初次見面但完全很自在～很開心的晚上：）', boy: '今天聊的很開心，辛苦了' },
{ girl: '謝謝你哦！！很愉快的夜晚', boy: '很開心聊一起很多事情，下次再一起看電影唷💕' },
{ girl: '謝謝你～～祝你順利被分到總部囉💪', boy: '謝謝你啊！ 推薦了好電影😃' },
// { girl: 'Thanks! It was a good movie.', boy: 'NA' },
{ girl: '菲律賓熊本熊的故事真的很有趣，恐龍真的很可愛吧🐲', boy: '真的很感謝你，這個超齡的優秀女孩：）' },
// { girl: '謝謝你等這麼久😂', boy: '下次別睡過頭了😏😏' },
{
  girl: '哈哈我剛到宿舍~今天謝謝你陪我看電影🙆和尼聊天很有趣~', boy: 'Hi 很開心和你看電影、在公園聊天，開心到忘了加聯絡方式xD 下面留一下我的 LINE ID，如果想繼續聯絡的話，可以加我:) 無論如何，謝謝你的陪伴~*****'
},
{ girl: '謝謝招待🙏遇到我辛苦了', boy: '不辛苦XD' },
{ girl: '今天謝謝你兒！！！😊', boy: '遇到一位不錯的女孩兒～～ 很開心' },
{ girl: '也很高興認識你～謝謝分享你的生活🧡還有分享很棒的課哈哈', boy: '很高興認識妳喔！' },
{ girl: '感謝你！和你看電影也很開心喔～', boy: '很高興跟你看電影' },
// { girl: '好！', boy: '下次一起再看電影吧' },
{ girl: '也很高興認識同年齡的你🤪', boy: '今天看了部好電影，謝謝妳😊' },
{ girl: '和你聊天很有趣～～請好好保重身體，週末愉快！😁', boy: '很高興認識你，妳也是保重身體' },
{ girl: '很開心認識你，能有相同的興趣真的很難得', boy: '很高興認識妳，遇到同輩也是一種有趣的事' },
{ girl: '今天很開心～', boy: '愉快的電影約會👏🏾' },
{ girl: '今天謝謝小綠～能和爽朗的你聊天很愉快，希望有機會再一起看其他電影😊', boy: '本人超可愛的Doris，很高興今天能跟妳一起看電影，有空可以常約一起看電影唷～' },
// { girl: '😆😆', boy: '謝謝妳！今天很開心' },
// { girl: '謝謝~~很開心認識你😂', boy: '謝謝妳！今天看電影很開心😃' },
{ girl: '😂謝謝你聽我說垃圾話~電影很好看~選的真好🙆', boy: '活潑稚氣女孩子，給人感覺舒適喔，謝謝給與美好的聚會' },
{ girl: '今天很開心 謝謝你', boy: '我們下次再約' },
{ girl: '很謝謝你的分享喔，下次再一起看電影～～😁', boy: '蠻開心的，有空在碰面聊聊天吧！' },
{ girl: '很有趣～竟然遇到減友哈哈哈', boy: '可以再約看電影囉！' },
// { girl: '', boy: '' },
// { girl: '有', boy: '加我吧，我的LINE ID：*******' },
{ girl: '再推薦我好看的電影🙌🏻', boy: '很高興認識妳喔' },
{ girl: '有話的話，下次見面說(⁎⁍̴̛ᴗ⁍̴̛⁎)', boy: '感謝感謝，很久沒有跟人一起看電影了' },
{ girl: '謝謝你陪我看電影', boy: '很可愛又不怕陌生人' },
// { girl: '😘😘', boy: '😘😘' },
{ girl: '謝謝你的電影！我看的很開心，覺得很好看～☺️', boy: '沒跟你要個聯絡方式😭如果不介意交個朋友的話，我的lineID是******，有機會可以再一起吃個飯之類的😂' },
{ girl: '你蠻幽默的 😆', boy: '感謝妳的赴約，有機會的話再約囉～' },
{ girl: '謝謝你的電影！很好看噢', boy: '謝謝一起出來看電影☺️' },
{ girl: 'Thanks u for the movie!', boy: '健談有禮，風格鮮明女孩' },
{ girl: '這次約的太趕了 謝謝你選的小丑女 很爽😂', boy: '很開心這次ㄧ起看電影😁😁有緣再聚😎😎' },
{ girl: '請多指教～', boy: '我會揪你出來玩的' },
// { girl: '謝謝 路上小心☺️', boy: '謝謝' },
{ girl: '嗨老人', boy: '下次見' },
{ girl: '謝謝你耶，這個下午辛苦你了，祝福你未來可以用這個服務找到合適的人！上帝祝福你～', boy: 'Hi **，很開心一起看電影和吃飯，謝謝你下車時都會幫我收踏板，團契愉快~' },
{ girl: 'nice 2 meet u😂', boy: '感謝妳的陪伴✌️' },
{ girl: '很高興有機會跟你一起看電影～', boy: '很好聊的**，下次可以約吃飯、聊天唷～' },
// { girl: '今天很開心，謝謝😊', boy: '****** 啊啊啊啊啊如果願意當朋友的話請加我' },
// { girl: '今天謝謝你呦😃', boy: '謝謝你跟我一起看電影' },
{ girl: '這次電影蠻有趣的！希望平凡的小日子多一點歡樂與開心💙', boy: '很高興妳來參加這次約會，希望妳吃喝看的開心，下次再約囉！' },
{ girl: '一起看電影很開心～', boy: '妳很好相處很好笑，謝謝妳一起看電影：）' },
{ girl: '今天謝謝你囉 隱形眼鏡戴不舒服還是戴著眼鏡吧😃', boy: '不客氣唷，不免俗還是po上我的社群媒體*****😃' },
{ girl: '謝謝今天的陪伴預祝你找到喜歡的工作', boy: '謝謝妳陪我看了一場恐怖片，覺得你是一個很有想法，也很有魅力的女生，感謝妳讓我認識直播主這個行業，之後有空再約看電影吧' },
// { girl: '謝謝你今天一起看電影☺️☺️☺️', boy: '☺️☺️☺️' },
{ girl: '真的很謝謝你願意陪我看這部電影，跟你聊天很有意思！回家小心～', boy: '有機會在一起看電影' },
{ girl: '謝謝你 是個很棒的男生', boy: '很棒 妳也很漂亮' },
{ girl: '今天很謝謝你，很高興認識你', boy: '和善聰明的女孩～也很可愛' },
// { girl: '😊😊', boy: '很開心一起看電影' },
{ girl: '很高興認識你～不好意思有突發狀況 我們下次再約喔', boy: '很開心認識妳🤡妳工作好酷 再約喔' },
// { girl: '謝謝你呦 回家晚了早點休息😃', boy: '謝謝妳' },
// { girl: '謝謝你的電影☺️', boy: 'Have a nice weekend' },
// { girl: '😀', boy: '😉' },
// { girl: '㊗️😀😀', boy: 'HI Anna，很開心今天和你聊天交流，有好活動可以揪一下喲' },
{ girl: '今天謝謝你囉，你的分享很特別～～～', boy: '很高興可以一起看電影，還有結束後的交流🙂' },
{ girl: '謝謝你', boy: '謝謝～意外看了這部愉快的小品，感覺很好～有好活動再出來走走: ) ' },
{ girl: '哈哈你還滿好聊的 謝謝電影招待😂', boy: '妳也很好聊啊，人又漂亮，之後有空也可以約吃飯呀～' },
{ girl: '今天謝謝你啦～', boy: '謝謝❤️今天很開心～有機會再一起出來' },
{ girl: '很高興認識你 今天很開心', boy: '愉快的夜晚，舒服的相處' },
{ girl: '下週一見囉', boy: '👍👍👍👍👍這個時候就文字冷淡一下😜' },
{ girl: '你的行動充在我這欸！今天電影不錯謝謝招待', boy: '啊 真的欸 那我找時間去跟你拿' },
{ girl: '謝謝今天一起看電影，真的很好看呢👍', boy: '意外好看的電影，本人也很隨和' },
{ girl: '很親切的感覺 聊天很開心哦😃', boy: '今天很開心，有機會再一起出來玩😉' },
// { girl: '謝謝請我看電影', boy: '跟妳約會很愉快😄' },
{ girl: '今天謝謝你請我看電影，還陪我等車喔🥺🙏', boy: 'Hello安，今天很開心跟你看電影喲，*****，有空一起去看抽屍剝繭吧～' },
]
